import type { ReactNode } from 'react';
import styles from './Badge.module.css';

/** Eigenschaften der Statusmarke. */
interface BadgeProps {
  /** Farbvariante: Erfolg, Warnung, Gefahr oder neutral. */
  tone?: 'success' | 'warning' | 'danger' | 'neutral';
  /** Beschriftung. */
  children: ReactNode;
}

/**
 * Kleine Statusmarke (z. B. aktiv/gesperrt). Die Bedeutung steht immer im Text, die Farbe ist nur
 * unterstützend (Barrierefreiheit).
 * @param props Farbvariante und Text.
 */
export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span className={`${styles.badge} ${styles[tone]}`}>{children}</span>;
}
